import { useEffect, useState } from 'react';

/**
 * Erkennt Handy-Viewports und hält den Wert bei Resize/Drehung aktuell.
 *
 * Bewusst viewport-basiert (matchMedia) statt User-Agent-Sniffing:
 * - funktioniert beim Drehen und Verkleinern des Fensters
 * - kein Fehlurteil bei neuen/unbekannten Geräten
 * - gleiche URL für Handy und Desktop -> keine SEO-/Cache-Probleme
 */
export const MOBILE_QUERY = '(max-width: 768px)';

export default function useIsMobile(query = MOBILE_QUERY) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const sync = () => setIsMobile(mql.matches);

    sync();

    // Safari < 14 kennt addEventListener auf MediaQueryList noch nicht
    const useModern = typeof mql.addEventListener === 'function';
    if (useModern) mql.addEventListener('change', sync);
    else mql.addListener(sync);

    // Fallback: manche Umgebungen (u. a. emulierte Viewports in DevTools)
    // feuern kein 'change' auf der MediaQueryList — resize deckt das mit ab.
    let frame = null;
    const onResize = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => { frame = null; sync(); });
    };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', sync);

    return () => {
      if (useModern) mql.removeEventListener('change', sync);
      else mql.removeListener(sync);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', sync);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [query]);

  return isMobile;
}
